export default "__VITE_ASSET__BrNb4pnm__"